import { Component, OnInit , ViewChild} from '@angular/core';
import { ChartType, ChartOptions, ChartDataSets } from 'chart.js';
import { MultiDataSet,SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip , Color} from 'ng2-charts';
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import {formatDate} from '@angular/common';
import { MainServiceService } from "src/app/services/main-service.service";
import { BaseChartDirective } from 'ng2-charts';
import { SpinnerService } from '../_services/spinner.service';
import { AlertService } from '../_services/alert.service';
import { StoreWiseSales, StoreWiseStocks } from './StoreWiseData.interface';
import { CheckboxControlValueAccessor } from '@angular/forms';
import { TryCatchStmt } from '@angular/compiler';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector:'app-new-dashboard',
    templateUrl: './new-dashboard.component.html',
    styleUrls: ['./new-dashboard.component.css']
})

export class NewDashboardComponent implements OnInit{
    periodIntervals = ['Today','Last 7 days','Last 30 days','Custom'];
    period:string = "";
    dateAD: string;
    dateBS: string;
    storeWiseSalesAll: StoreWiseSales[] =[];
    ownedStoreSales: StoreWiseSales[] = [];
    franchiseStoreSales: StoreWiseSales[];
    totalOwnedSales: number =0;
    totalOwnedQty: number = 0;
    totalFranchiseSales: number = 0;
    totalFranchiseQty: number = 0 ;
    storeWiseStockAll: StoreWiseStocks[]=[];
    ownedStoreStock: StoreWiseStocks[];
    franchiseStoreStock: StoreWiseStocks[];
    totalOwnedStockVal: number;
    totalOwnedStockQty: number;
    totalFranchiseStockQty: number;
    totalFranchiseStockVal: number;
    fromDate:any;
    toDate:any; 
    reportType:string ="sales";

    OwnedStore:string="Owned Store Sales"
    FranchiseStore:string="Franchise Store Sales"
    OwnedVSFranchise:string="Owned VS Franchise Sales"

    salesstock = false;
    salesCheck = false;
    stockCheck = false;

    @ViewChild(BaseChartDirective) public chart: BaseChartDirective;
    @ViewChild("ownerFranchise") public ownerFranchisechart: BaseChartDirective;
    @ViewChild("franchiseWise") public franchiseWisechart: BaseChartDirective;
    @ViewChild("ownedWise") public ownedWisechart: BaseChartDirective;


    //ownerVSfranchise pie chart
    public ownerFranchiseLabels: Label[] = [['Owned Store'],['Franchise Store']] ;
    public ownerFranchiseData: SingleDataSet = [] ;
    public ownerFranchiseType: ChartType = 'pie';
    public ownerFranchiseOptions: ChartOptions ={
        responsive: true,
        legend: {
          position: 'bottom',
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              const label = ctx.chart.data.labels[ctx.dataIndex];
              return label;
            },
          },
        }
      };
    public ownerFranchiseLegend = true;
    public ownerFranchisePlugins = [];
    public pieChartColors: Array < any > = [{
        backgroundColor: ['#9ccae4', '#e49cbe']
      }];

    //franchise bar chart
    public franchiseWiseLabels: Label[] = [];
  public franchiseWiseData: SingleDataSet = [];
  public franchiseWiseColor: Color[]=[{
    backgroundColor: 'skyblue'
  }]
  public franchiseWiseType: ChartType = 'horizontalBar';
  public franchiseWiseLegend = false;
  public franchiseWiseOptions: ChartOptions = {responsive:true};
  
  //owned store bar chart
  public ownedLabels: Label[]=[];
  public ownedData: SingleDataSet = [];
  public ownedColor: Color[] = [{backgroundColor:'#88df8a'}]
  public ownedType:ChartType = 'horizontalBar';
  public ownedLegend = false;
  public ownedOptions: ChartOptions = {responsive:true}
    lastWeek: string;
    lastMonth: string;
 

    private FranchiseWiseClicked(e:any):void {
        var label: string;
        var compID: string;
        if(e.active.length > 0) {
        console.log("Index", e.active[0]._index);
        console.log("Data" , e.active[0]._chart.config.data.datasets[0].data[e.active[0]._index]);
        console.log("Label" , e.active[0]._chart.config.data.labels[e.active[0]._index]);
            label = e.active[0]._chart.config.data.labels[e.active[0]._index];
        }

        console.log('storewiseAll',this.storeWiseSalesAll);
        

        if(!this.salesCheck){
            for(var i = 0; i < this.storeWiseSalesAll.length; i++){
                if( label == this.storeWiseSalesAll[i].StoreName ){
                    console.log('FOUND IT', label, this.storeWiseSalesAll[i].StoreName);
                        compID = this.storeWiseSalesAll[i].COMPANYID;
                        this.router.navigate(["reports/categoryWiseSales", label]);
                }
            }
        }


        }


    constructor(
        private http: HttpClient,
        private masterService: MainServiceService,
        private spinner:SpinnerService,
        private alert:AlertService,
        private router: Router ){
            monkeyPatchChartJsTooltip();
            monkeyPatchChartJsLegend();
            this.ownerFranchiseData = [];
            this.period = 'Today'
    }

    ngOnInit():void {
        const time = new Date();
        this.dateAD = formatDate(time,'yyyy-MM-dd','en-US');
       this.changeDate(this.dateAD,'AD');
       console.log("english and neplai date", this.dateAD,this.dateBS);
        
      this.masterLoadReportSales(this.dateAD,this.dateAD);
    }

    loadAllData(data:Array<StoreWiseSales>){
        console.log("data", data);
        this.totalOwnedSales = 0;
        this.totalOwnedQty = 0;
        this.totalFranchiseQty = 0;
        this.totalFranchiseSales= 0;
        this.franchiseWiseData = [];
        this.franchiseWiseLabels = [];
        this.ownedLabels = [];
        this.ownedData = [];

        this.ownedStoreSales = data.filter(x=> x.IsFranchise == 0);
        this.franchiseStoreSales = data.filter(x=> x.IsFranchise == 1);
        console.log("owned and frnachise data", this.ownedStoreSales, this.franchiseStoreSales);
      
        //for ownedvsfrnahcise pie chart
        this.ownedStoreSales.forEach( x=>{
            this.totalOwnedSales += this.nullToZeroConverter(x.TotalSales);
            this.totalOwnedQty += this.nullToZeroConverter(x.UnitSold);
        });

        this.franchiseStoreSales.forEach( x=>{
            this.totalFranchiseSales += this.nullToZeroConverter(x.TotalSales);
            this.totalFranchiseQty += this.nullToZeroConverter(x.UnitSold);
        })
        console.log("owned", this.totalOwnedQty,this.totalOwnedSales);
        console.log("franchise", this.totalFranchiseQty,this.totalFranchiseSales);
        if(this.reportType == "sales"){
            this.ownerFranchiseData = [this.totalOwnedSales,this.totalFranchiseSales];

        }else if(this.reportType == "qty"){
            this.ownerFranchiseData = [this.totalOwnedQty,this.totalFranchiseQty];
        }
        
        //for franchiseStoreSales
       for (const key in this.franchiseStoreSales) {
           if(this.franchiseStoreSales[key].TotalSales !== null){
               if(this.reportType == "sales"){
                this.franchiseWiseData[key] = this.franchiseStoreSales[key].TotalSales;
               }
               else if( this.reportType =="qty"){
                   this.franchiseWiseData[key] = this.franchiseStoreSales[key].UnitSold;
               }
            this.franchiseWiseLabels[key] = this.franchiseStoreSales[key].StoreName;
           }
       
       }

       //for ownedStoreSales
       for (const key in this.ownedStoreSales) {
          if(this.ownedStoreSales.length > 0){
              if(this.ownedStoreSales[key].TotalSales !== null){
                  if(this.reportType == "sales"){
                    this.ownedData[key] = this.ownedStoreSales[key].TotalSales;

                  }else if(this.reportType =="qty"){
                    this.ownedData[key] = this.ownedStoreSales[key].UnitSold;

                  }
                  this.ownedLabels[key] = this.ownedStoreSales[key].StoreName;
              }
          }else{
              this.ownedStoreSales = [];
              this.ownedData = [];
              this.ownedLabels = [];
          }
       }
       console.log("franchise store sales", this.franchiseWiseData,this.franchiseWiseLabels);
       console.log("owned store sales", this.ownedData,this.ownedLabels);

    }

    changeDate(value, format:string){
        console.log("date to  change", value);
        var adbs = require("ad-bs-converter");
        if(format == "AD"){
          var adDate = (value.replace("-","/")).replace("-","/");
          var bsDate = adbs.ad2bs(adDate);
          this.dateBS= (bsDate.en.day == '1'|| bsDate.en.day =='2' || bsDate.en.day =='3' || bsDate.en.day =='4' || bsDate.en.day =='5' || bsDate.en.day =='6' || bsDate.en.day =='7' || bsDate.en.day =='8' || bsDate.en.day =='9'? '0' + bsDate.en.day:bsDate.en.day)+'/'+bsDate.en.month + '/' + bsDate.en.year;
          
          console.log("date converted",this.dateBS);
        }else if( format == "BS"){
          var datearr = value.split('/');
          console.log("datee arr", datearr);
          const bsDate = datearr[2]+"/"+datearr[1]+"/"+datearr[0];
          var adDate = adbs.bs2ad(bsDate);
          console.log("AD DATE changedd", adDate);
          this.dateAD = (adDate.year + '-'+((adDate.month).toString().length == 1?'0'+adDate.month :adDate.month)+'-'+((adDate.day).toString().length == 1 ? '0' + adDate.day : adDate.day));
          console.log("convert to AD",this.dateAD)
        }
      }

      changeSalesStock(event){
          console.log(event);
            this.salesstock = !this.salesstock;
            if(this.salesstock){
                this.reportType = 'stockval';
                this.FranchiseStore = "Franchise Store Stock";
                this.OwnedStore="Owned Store Stock";
                this.OwnedVSFranchise="Owned VS Franchise Stock";
            }
            else{
                this.reportType = 'sales';
                this.FranchiseStore = "Franchise Store Sales";
                this.OwnedStore="Owned Store Sales";
                this.OwnedVSFranchise="Owned VS Franchise Sales"
            }

            if(this.period == 'Custom'){
                this.loadReport();
            }else{
                this.onChange();
            }
      }

      nullToZeroConverter(value) {

        if (
          value === undefined ||
          value == null ||
          value === null ||
          value === '' ||
          value === 'Infinity' ||
          value === 'NaN' ||
          value === NaN ||
          isNaN(parseFloat(value))
        ) {
          return 0;
        }
        return parseFloat(value);
      }

   

      loadReport(){
          console.log("ddww", this.period,this.fromDate,this.toDate,this.reportType)
          if(this.salesstock){
              this.masterLoadReportStock(this.fromDate, this.toDate);
          }
          else{
            this.masterLoadReportSales(this.fromDate,this.toDate);
          }
        }

        updateCharts(){
            this.ownerFranchisechart.chart.update();
            this.franchiseWisechart.chart.update();
            this.ownedWisechart.chart.update();
        return;
        }


        onChange(){

            if(this.salesstock){    
            
                console.log("change value", this.period);
                if(this.period == 'Today'){
                 this.masterLoadReportStock(this.dateAD,this.dateAD);
                }
                else if(this.period == 'Last 7 days'){
                    let currDate = new Date();
                    let lastWeekDate = currDate.getDate()-7;
                    currDate.setDate(lastWeekDate);
                    this.lastWeek = formatDate(currDate,'yyyy-MM-dd','en-US');
                    console.log("last 7 days", this.lastWeek)
                    this.masterLoadReportStock(this.lastWeek,this.dateAD);
    
                }else if(this.period == 'Last 30 days'){
                    let currDate = new Date();
                    let lastMonthDate = currDate.getDate()-30;
                    currDate.setDate(lastMonthDate);
                    this.lastMonth = formatDate(currDate,'yyyy-MM-dd','en-US');
                    console.log("last 7 days", this.lastMonth);
                    this.masterLoadReportStock(this.lastMonth,this.dateAD);
    
                }

            }
      
            else{
            
                console.log("change value", this.period);
                if(this.period == 'Today'){
                 this.masterLoadReportSales(this.dateAD,this.dateAD);
                }
                else if(this.period == 'Last 7 days'){
                    let currDate = new Date();
                    let lastWeekDate = currDate.getDate()-7;
                    currDate.setDate(lastWeekDate);
                    this.lastWeek = formatDate(currDate,'yyyy-MM-dd','en-US');
                    console.log("last 7 days", this.lastWeek)
                    this.masterLoadReportSales(this.lastWeek,this.dateAD);
    
                }else if(this.period == 'Last 30 days'){
                    let currDate = new Date();
                    let lastMonthDate = currDate.getDate()-30;
                    currDate.setDate(lastMonthDate);
                    this.lastMonth = formatDate(currDate,'yyyy-MM-dd','en-US');
                    console.log("last 7 days", this.lastMonth);
                    this.masterLoadReportSales(this.lastMonth,this.dateAD);
    
                }

            }
        }

        masterLoadReportSales(fromdate:string,todate:string){
            console.log("from and to date", fromdate, todate);
            this.spinner.show("loading data, Please Wait");
            this.masterService.masterGetMethod("/DashBoard/GetStoreWiseSales?Date1="+fromdate+"&Date2="+todate).subscribe((res:any)=>{
                if(res.status == "ok"){
                    this.storeWiseSalesAll = res.result;
                    console.log("fromm custom date", this.storeWiseSalesAll);
                    this.loadAllData(this.storeWiseSalesAll);
                    this.spinner.hide();
    
                    this.updateCharts();
    
                }else{
                    this.spinner.hide();
                    this.alert.error("Error loading data");
                }
            },error=>{
                this.spinner.hide();
                this.alert.error(error);
            });

        }

        masterLoadReportStock(fromdate:string,todate:string){
          console.log("from and to date", fromdate, todate);
          this.spinner.show("loading data, Please Wait");
          this.masterService.masterGetMethod("/DashBoard/GetStoreWiseStocks?Date1="+fromdate+"&Date2="+todate).subscribe((res:any)=>{
              if(res.status == "ok"){
                  this.storeWiseStockAll = res.result;
                  console.log("fromm custom date", this.storeWiseStockAll);
                  this.loadAllStockData(this.storeWiseStockAll);
                  this.spinner.hide();
  
                  this.updateCharts();
  
              }else{
                  this.spinner.hide();
                  this.alert.error("Error loading data");
              }
          },error=>{
              this.spinner.hide();
              this.alert.error(error);
          });

          console.log("this.storeWiseStockAll", this.storeWiseStockAll);

      }

      loadAllStockData(data:Array<StoreWiseStocks>){
        console.log("data", data);
        this.totalOwnedStockVal = 0;
        this.totalOwnedStockQty = 0;
        this.totalFranchiseStockQty = 0;
        this.totalFranchiseStockVal= 0;
        this.franchiseWiseData = [];
        this.franchiseWiseLabels = [];
        this.ownedLabels = [];
        this.ownedData = [];

        this.ownedStoreStock = data.filter(x=> x.IsFranchise == 0);
        this.franchiseStoreStock = data.filter(x=> x.IsFranchise == 1);
        console.log("owned and frnachise data", this.ownedStoreStock, this.franchiseStoreStock);
      
        //for ownedvsfrnahcise pie chart
        this.ownedStoreStock.forEach( x=>{
            this.totalOwnedStockVal += this.nullToZeroConverter(x.TotalStockValue);
            this.totalOwnedStockQty += this.nullToZeroConverter(x.UnitsInStock);
        });

        this.franchiseStoreStock.forEach( x=>{
            this.totalFranchiseSales += this.nullToZeroConverter(x.TotalStockValue);
            this.totalFranchiseQty += this.nullToZeroConverter(x.TotalStockValue);
        })
        console.log("owned", this.totalOwnedStockQty,this.totalOwnedStockVal);
        console.log("franchise", this.totalFranchiseStockQty,this.totalFranchiseStockVal);
        if(this.reportType == "stockval"){
            this.ownerFranchiseData = [this.totalOwnedStockVal,this.totalFranchiseStockVal];

        }else if(this.reportType == "stockqty"){
            this.ownerFranchiseData = [this.totalOwnedStockQty,this.totalFranchiseQty];
        }
        
        //for franchiseStoreSales
       for (const key in this.franchiseStoreStock) {
           if(this.franchiseStoreStock[key].TotalStockValue !== null){
               if(this.reportType == "stockval"){
                this.franchiseWiseData[key] = this.franchiseStoreStock[key].TotalStockValue;
               }
               else if( this.reportType =="stockqty"){
                   this.franchiseWiseData[key] = this.franchiseStoreStock[key].UnitsInStock;
               }
            this.franchiseWiseLabels[key] = this.franchiseStoreStock[key].StoreName;
           }
       
       }

       //for ownedStoreSales
       for (const key in this.ownedStoreStock) {
          if(this.ownedStoreStock.length > 0){
              if(this.ownedStoreStock[key].TotalStockValue !== null){
                  if(this.reportType == "stockval"){
                    this.ownedData[key] = this.ownedStoreStock[key].TotalStockValue;

                  }else if(this.reportType =="stockqty"){
                    this.ownedData[key] = this.ownedStoreStock[key].UnitsInStock;

                  }
                  this.ownedLabels[key] = this.ownedStoreStock[key].StoreName;
              }
          }else{
              this.ownedStoreStock = [];
              this.ownedData = [];
              this.ownedLabels = [];
          }
       }
       console.log("franchise store sales", this.franchiseWiseData,this.franchiseWiseLabels);
       console.log("owned store sales", this.ownedData,this.ownedLabels);

       
    }

        onTypeChange(){
            console.log("type report type", this.reportType);
            console.log('this..storewisesalesall', this.storeWiseStockAll);

            if(!this.salesstock){
                if(this.salesCheck == false){
                    this.reportType = 'sales';
                }
                else{
                    this.reportType = 'qty';
                }
                this.loadAllData(this.storeWiseSalesAll);
                this.updateCharts();
            }

            else{
                if(this.stockCheck == false){
                    this.reportType = 'stockval';
                }
                else{
                    this.reportType = 'stockqty';
                }
                this.loadAllStockData(this.storeWiseStockAll);
                this.updateCharts();
            }

            // if(this.period == 'Custom'){
            //     this.loadReport();
            // }else{
            //     this.onChange();
            // }
        }

        FranchiseClick(event){
            console.log('FranchiseClick', event);
        }
}